// ============================================================
// SWIPER SLIDERS
// ============================================================

import Swiper from 'swiper/bundle';

export function initSwiperSliders() {
    const opinionsEl = document.querySelector('.opinions-slider__swiper');

    if (opinionsEl) {
        new Swiper(opinionsEl, {
            speed: 600,
            slidesPerView: 1,
            spaceBetween: 16,
            //loop: true,

            breakpoints: {
                576: { slidesPerView: 1.3 },
                992: { slidesPerView: 1.3 },
                1200: { slidesPerView: 2.05 },
            },

            navigation: {
                prevEl: '.opinions-slider__arrow--prev',
                nextEl: '.opinions-slider__arrow--next',
            },

            pagination: {
                el: '.opinions-slider__pagination',
                clickable: true,
            },

            a11y: {
                prevSlideMessage: 'Poprzednia opinia',
                nextSlideMessage: 'Następna opinia',
                paginationBulletMessage: 'Przejdź do opinii {{index}}',
            },
        });
    }
}